import { useMemo } from "react";
import getForecastMonthList from "../../../tools/forecast/getForecastMonthList";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import ForecastTotalData from "./ForecastTotalData";

const ForecastTotal = ({ forecastDates } : {forecastDates: string }) => {
    const monthList = useMemo(() => getForecastMonthList(forecastDates), [forecastDates]);
    
    // Récupération brute des totaux depuis Redux
    const rawTotals = useSelector((state: RootState) => state.forecast.totals);

    const totalBySection = useMemo(() => {
        const totals: any = rawTotals || {};

        return {
            "CA - Régie": totals["Régie"] || {},
            "CA - Forfait": totals["Forfait"] || {},
            "CA - Hébergement": totals["Hébergement"] || {},
            "CA - TMA/TME": totals["TMA/TME"] || {},
            "CA - TRA": totals["TRA"] || {},
            "Salariés": totals["Salariés"] || {},
            "TNS": totals["TNS"] || {},
            "Frais de fonctionnement": totals["Frais de fonctionnement"] || {},
            "Investissements": totals["Investissements"] || {},
            "Entreprise": totals["Entreprise"] || {},
            // Fusion simplifiée de la sous-traitance
            "Sous-traitance": (totals["Sous-traitance-Forfait"] && totals["Sous-traitance-Régie"]) 
                ? Object.keys(totals["Sous-traitance-Forfait"]).reduce((acc: any, key) => {
                    acc[key] = (totals["Sous-traitance-Forfait"][key] || 0) + 
                               (totals["Sous-traitance-Régie"][key] || 0);
                    return acc;
                }, {})
                : (totals["Sous-traitance-Forfait"] || totals["Sous-traitance-Régie"] || {}),
            "DGFIP": totals["DGFIP"] || {},
        };
    }, [rawTotals]);

    return (
        <ForecastTotalData 
            monthList={monthList} 
            totalBySection={totalBySection} 
        />
    );
}

export default ForecastTotal;